import { render, staticRenderFns } from "./FactDetail.vue?vue&type=template&id=79b5726b&scoped=true"
import script from "./FactDetail.vue?vue&type=script&lang=js"
export * from "./FactDetail.vue?vue&type=script&lang=js"
import style0 from "./FactDetail.vue?vue&type=style&index=0&id=79b5726b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b5726b",
  null
  
)

export default component.exports